<template>
  <el-dialog :title="title" :visible.sync="domVisible" custom-class="changePhone" :lock-scroll="false" :before-close="handleClose" v-loading="loading">
    <div slot="title" class="dialogTitle" :class="{'text_yellow':authStatus==1}">{{authStatus!=1?authTitle:$t('enum.declined')}}</div>
    <div class="">
      <div class="jumioBox" v-if="authStatus!=2">
        {{authStatus==1?$t('kyc.Verifyfailed'):$t('kyc.verifyyouridentity')}}
      </div>
      <div class="jumioBox" v-if="authStatus==2">{{$t('base.processing')}}......</div>
      <span class="tips">{{$t('kyc.identityinformation')}}</span>
      <span class="tips">{{$t('kyc.24hours3times')}}</span>
      <!-- <div class="powerJumio">powered by jumio</div> -->
      <div class="footerBtn" v-if="authStatus!=2">
        <el-button size="small" @click="handleClose()">{{$t('base.cancel')}}</el-button>
        <el-button type="primary" @click="SetIDVerification()">{{authStatus==1?$t('kyc.Applyagain'):$t('kyc.Verify')}}</el-button>
      </div>
      <div class="footerBtn" v-if="authStatus==2">
        <el-button type="primary" @click="handleClose('toInfo')">{{$t('base.confirm')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      authTitle: '',
      loading: false,
      authStatus: '', //0:待认证,1:失败
      dislogType: this.$enumInfo.dislogType,
      userInfo: null
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    type: Number,
    //userInfo: {}
  },
  watch: {},
  filters: {},
  created() {
    this.authStatus = this.type
    this.authTitle = this.title
  },
  mounted() {
    let that = this
    that.getQueryUserAuth()
  },
  methods: {
    handleClose(val) {
      let that = this
      if (val == 'toInfo') {
        that.$router.push({
          path: '/mycardhobby/setting'
        })
      }
      this.$emit('closeDialog', 'idverification', false)
    },
    //查询用户认证状态
    getQueryUserAuth() {
      let that = this
      that.userInfo = getInfo()
      that.loading = true
      if (that.userInfo.VerifyStatus != 2) {
        that.$get(that.$interface.QueryUserAuth, { Id: that.userInfo.MappingUserId }).then(res => {
          that.loading = false
          if (res.Result) {
            if (res.Data == 0) {
              that.authStatus = 0
            }
            if (res.Data == 3) {
              that.authStatus = 1
            }
            if (res.Data == 1) {
              that.authStatus = 2
              that.authTitle = ""
            }
          } else {
            that.$message({
              type: 'error',
              duration: 1000,
              message: res.Msg
            });
          }
        })
      } else {
        that.handleClose()
      }

    },
    setIDForOther() {
      let that = this
      that.$post(that.$interface.CreateIDForOther, { Id: that.userInfo.MappingUserId }).then(res => {
        if (res.Result) {
          var url = res.Data.web.href
          //return url
          //console.log(url)
          window.location.href = url;
        } else {
          that.loading = false
          that.$message({
            type: "error",
            duration: 1000,
            message: res.Msg
          });
        }
      })
    },
    SetIDVerification() {
      let that = this
      that.loading = true
      that.setIDForOther()
      // if (this.userInfo.MemberSource != 'US') {
      //   that.setIDForOther()
      // } else {
      //   this.$emit('openCloseDialog', 'verifynow', 'idverification', true, false)
      // }
    },
  },
  beforeDestroy() {
    this.handleClose()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialogTitle {
  line-height: 24px;
  font-size: 18px;
}

.jumioBox {
  padding: 12px 0;
  text-align: center;
  min-height: 70px;
  width: 84%;
  line-height: 1.5;
  margin: 0 auto;
  font-size: 16px;
}

.jumioBox .tips {
  font-size: 12px;
  display: block;
  color: #a0a0a0;
  margin: 10px 0;
}

.powerJumio {
  display: flex;
  justify-content: center;
  color: #a0a0a0;
  margin-bottom: 20px;
}

/*.powerJumio:before {
  content: '';
  height: auto;
  width: 45px;
  background: url(/static/images/icon/icon_logo_jumio.png) no-repeat;
  background-size: contain;
  margin-right: 8px;
}*/

.footerBtn {
  text-align: right;
  padding-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/jumioVerify.vue